function checkPointNotInRotatedImage(x, y, width, height, rotation) {
  // TODO calculate actual image area from rotated image, use max value for now
  var max = (width > height) ? width : height;
  max = max * 1.42;
  // ... insert maths here
  if (x < 0 || x > max || y < 0 || y > max) {
    return true;
  }
  return false;
}

module.exports = checkPointNotInRotatedImage;


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-settings-check/utils/checkPointNotInRotatedImage.js
// module id = 444
// module chunks = 0